import React from 'react';
import ActiveChatsComponent from './ActiveChatsComponent';

function ActiveChats({ activeChats, removeUserById }) {
    return (
        <div style={{
            'display': 'flex',
            'justifyContent': 'center',
            'position': 'fixed',
            'bottom': '0',
            'right': '302px',
            'maxWidth': '910px',
            'height': '400px'
        }}>{activeChats.map((activeChat) => {
            return (
                <ActiveChatsComponent
                    activeChat={activeChat}
                    removeUserById={removeUserById}
                    key={`${activeChat.op}`}
                />
            )
        })}</div>
    )
}

export default ActiveChats